import { render, staticRenderFns } from "./add-one-candidate-new-job.vue?vue&type=template&id=51a75822&scoped=true"
import script from "./add-one-candidate-new-job.vue?vue&type=script&lang=ts"
export * from "./add-one-candidate-new-job.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a75822",
  null
  
)

export default component.exports